import { useAuth } from '../contexts/AuthContext';
import { OrgPermissions } from '../types/permissions';

export const usePermissions = () => {
  const { permissions, orgRole } = useAuth();

  const can = (permission: keyof OrgPermissions): boolean => {
    if (!permissions) return false;
    // If the key doesn't exist yet in DB (new permission on old role),
    // fall back to true for owner/admin so they're never locked out.
    if (permissions[permission] === undefined) {
      return orgRole === 'owner' || orgRole === 'admin';
    }
    return permissions[permission] === true;
  };

  const isOwner = orgRole === 'owner';
  const isAdmin = orgRole === 'admin' || orgRole === 'owner';

  return { can, permissions, isOwner, isAdmin };
};
